import React, { useEffect, useState } from 'react';

export default function DecimalInput({
  value,
  onChange,
  decimalPlaces = 2,
  readOnly,
  placeholder,
  ...props
}) {
  const [digits, setDigits] = useState('');

  useEffect(() => {
    if (value === undefined || value === null || value === '') {
      setDigits('');
      return;
    }
    const num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
    if (!isNaN(num)) {
      setDigits(String(Math.round(num * Math.pow(10, decimalPlaces))));
    }
  }, [value, decimalPlaces]);

  const emit = (d) => {
    const val = Number(d || 0) / Math.pow(10, decimalPlaces);
    if (onChange) onChange({ target: { value: val, name: props.name } });
  };

  const handleKeyDown = (e) => {
    if (readOnly) return;
    if (/^[0-9]$/.test(e.key)) {
      e.preventDefault();
      const newDigits = (digits + e.key).replace(/^0+/, '');
      setDigits(newDigits);
      emit(newDigits);
    } else if (e.key === 'Backspace') {
      e.preventDefault();
      const newDigits = digits.slice(0, -1);
      setDigits(newDigits);
      emit(newDigits);
    }
  };


  const formatDigits = (d) => {
    if (!d) return '';
    const padded = d.padStart(decimalPlaces + 1, '0');
    const intPart = padded.slice(0, -decimalPlaces);
    const decPart = padded.slice(-decimalPlaces);
    return `${intPart},${decPart}`;
  };

  const inputProps = {
    ...props,
    type: 'text',
    value: formatDigits(digits),
    onKeyDown: handleKeyDown,
    readOnly,
  };

  if (!readOnly && placeholder !== undefined) {
    inputProps.placeholder = placeholder;
  }

  return <input {...inputProps} />;
}
